module.exports = __webpack_public_path__ + "img/award.aa92333f.png";